import React, { useEffect, useState } from 'react';
import "../../Css/Home/HomeBrand.css";
import axios from 'axios';
import { Link } from 'react-router-dom';

const HomeBrand = () => {
    const [brandData, setBrandData] = useState([]);

    const fetchBrand = async () => {
        try {
            const response = await axios.get(`https://api.woodsy.co.in/api/brands`);
            setBrandData(response?.data?.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchBrand();
    }, []);

    return (
        <div>
            <section className='home-section-brand-main-con'>
                <div className='container'>
                    <div className='home-section-brand-details-main-con'>
                        <div className='home-about-section-details-main-con home-brand-section-details-main-con'>
                            <h2 className='ttcmsabout-title'>Our Popular Brands</h2>
                        </div>

                        <div className='marquee'>
                            <div className='marquee__inner'>
                                {[...brandData, ...brandData].map((elem, index) => (
                                    <Link to={`/product?brand_slug=${elem.slug}`} key={index}>
                                        <div className='home-section-brand-card-main-con'>
                                            <img src={elem.image} alt={elem.slug} />
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeBrand;
